import { Link, usePathname } from 'expo-router';
import { StyleSheet, View } from 'react-native';

import {
  ActionSheet,
  Button,
  IconClose,
  IconDelivery,
  IconStore,
  Pressable,
  Text,
  createMqStyles,
  tokens,
  useMqSelect,
} from '@fhs/ui';

export const ServiceModeActionSheet = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const mqStyles = useMqStyles();
  const isDesktop = useMqSelect({ $gteDesktop: true }, false);
  const pathname = usePathname();
  return (
    <ActionSheet isVisible={isOpen} onClose={() => onClose()} grabber={false}>
      <View style={mqStyles.container}>
        {!isDesktop && (
          <View style={styles.storeIconContainer}>
            <IconStore size={40} />
          </View>
        )}
        <View style={styles.titleContainer}>
          <Text.Heading type={isDesktop ? 'two' : 'three'} style={mqStyles.text}>
            How Are You Getting Your Order?
          </Text.Heading>
          {isDesktop ? (
            <View style={styles.closeIconContainer}>
              <Pressable aria-label="Close" accessibilityLabel="Close" onPress={onClose}>
                <IconClose
                  size={32}
                  accessibilityElementsHidden
                  importantForAccessibility="no-hide-descendants"
                />
              </Pressable>
            </View>
          ) : null}
        </View>
        <Text.Paragraph size="md" style={mqStyles.text}>
          Let us know if it's pick-up or delivery to show you the best available options.
        </Text.Paragraph>
        <View style={mqStyles.buttonsContainer}>
          <Link
            href={`/store-locator/service-mode?back=${pathname}`}
            asChild
            style={mqStyles.button}
          >
            <Button size="lg" onPress={() => onClose()}>
              <Button.Icon>
                <IconStore />
              </Button.Icon>
              <Button.Text>Pickup</Button.Text>
            </Button>
          </Link>
          <Link href={`/store-locator/address?back=${pathname}`} asChild style={mqStyles.button}>
            <Button type="outline" size="lg" onPress={() => onClose()}>
              <Button.Icon>
                <IconDelivery />
              </Button.Icon>
              <Button.Text>Delivery</Button.Text>
            </Button>
          </Link>
        </View>
      </View>
    </ActionSheet>
  );
};

export const styles = StyleSheet.create({
  storeIconContainer: {
    backgroundColor: tokens.colors.$blackOpacity04,
    borderRadius: 100,
    padding: 10,
  },
  closeIconContainer: {
    position: 'absolute',
    right: -10,
    top: -2,
  },
  titleContainer: {
    position: 'relative',
  },
});

export const useMqStyles = createMqStyles({
  container: {
    $base: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: 18,
      gap: 12,
    },
    $gteDesktop: {
      alignItems: 'stretch',
      paddingVertical: 30,
      paddingHorizontal: 36,
      gap: 24,
    },
  },
  text: {
    $base: {
      textAlign: 'center',
    },
    $gteDesktop: {
      textAlign: 'left',
    },
  },
  buttonsContainer: {
    $base: {
      width: '100%',
      gap: 12,
    },
    $gteDesktopLg: {
      flexDirection: 'row-reverse',
      gap: 16,
    },
  },
  button: {
    $base: {
      width: '100%',
    },
    $gteDesktop: {
      flex: 1,
    },
  },
});
